export const PSC_TYPE = 'PSC';
export const NAICS_TYPE = 'NAICS';
